import { nanoid } from "nanoid";

export const notesData = [
  {
    id: nanoid(),
    title:
      "sunt aut facere repellat provident occaecati excepturi optio reprehenderit",
    text: `quia et suscipit
      suscipit recusandae consequuntur expedita et cum
      reprehenderit molestiae ut ut quas totam
      nostrum rerum est autem sunt rem eveniet architecto`,
  },
  {
    id: nanoid(),
    title: "qui est esse",
    text: `est rerum tempore vitae
      sequi sint nihil reprehenderit dolor beatae ea dolores neque
      fugiat blanditiis voluptate porro vel nihil molestiae ut reiciendis
      qui aperiam non debitis possimus qui neque nisi nulla`,
  },
  {
    id: nanoid(),
    title: "ea molestias quasi exercitationem repellat qui ipsa sit aut",
    text: `et iusto sed quo iure
      voluptatem occaecati omnis eligendi aut ad
      voluptatem doloribus vel accusantium quis pariatur
      molestiae porro eius odio et labore et velit aut`,
  },
  {
    id: nanoid(),
    title: "eum et est occaecati",
    text: `ullam et saepe reiciendis voluptatem adipisci
      sit amet autem assumenda provident rerum culpa
      quis hic commodi nesciunt rem tenetur doloremque ipsam iure
      quis sunt voluptatem rerum illo velit`,
  },
];
